import React from 'react';
import { isWinterResort } from 'Utils/resort/resortUtils';
import { CandyBar } from './CandyBar';
type Props = {
  i18n: CMSContent;
  proposal: Proposal;
  resort: Product;
};
export const ParticipantsReassurance = ({ i18n, resort, proposal }: Props) => (
  <CandyBar
    allInclusive={{
      text:
        proposal?.packageId === 'RON' ? null : i18n.booking.participants.rassurance.allInclusive,
    }}
    fidelity={{
      text: i18n.booking.participants.rassurance.fidelity,
    }}
    spreadPayment={{
      number: i18n.booking.participants.rassurance.paymentHeader,
      text: i18n.booking.participants.rassurance.paymentText,
    }}
    type={isWinterResort(resort) ? 'winter' : 'summer'}
  />
);
